import SolicitudTraslado from "../../../views/administrador/Bodega/SolicitudTraslado";
import TransferenciaStock from "../../../views/administrador/Bodega/TransferenciaStock";
import Inventario from "../../../views/administrador/Bodega/Inventario"
import Tags from "../../../views/administrador/Bodega/Tags"
import InformeInventario from "../../../views/administrador/Bodega/InformeInventario"
import EntradaMercancias from "../../../views/administrador/Bodega/EntradaMercancias"
import Entregas from "../../../views/administrador/Bodega/Entregas"




const routes_bodega = [
  {
    path: "/SolicitudTraslado",
    name: "Solicitud de Traslado ",
    icon: "",
    component: SolicitudTraslado,
    doNotShow: true,
  },
   {
    path: "/TransferenciaStock",
    name: "Transferencias de Stock",
    icon: "",
    component: TransferenciaStock,
    doNotShow: true,
  },
  {
    path: "/Inventario",
    name: "Inventario",
    icon: "",
    component: Inventario,
    doNotShow: true,
  },
  {
    path: "/Tags",
    name: "Tags",
    icon: "",
    component: Tags,
    doNotShow: true,
  },
  {
    path: "/InformeInventario",
    name: "Informe Inventario",
    icon: "",
    component: InformeInventario,
    doNotShow: true,
  },
  {
    path: "/EntradaMercancias",
    name: "Entrada de Mercancias",
    icon: "",
    component: EntradaMercancias,
    doNotShow: true,
  },
  {
    path: "/Entregas",
    name: "Entregas",
    icon: "",
    component: Entregas,
    doNotShow: true,
  },
 
];

export default routes_bodega;
